<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="col-lg-12">
    <b-row>
        <b-col style="text-align:center">
          <h5>Adimat - Proyecto editorial</h5>
        </b-col>
    </b-row>
  </div>
  <div class="card">
    <b-row class="sparkline">
        <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card">
                <div class="body xl-blue">
                    <h6>Cursos</h6>
                    <h2 class="m-0">{{ stats.courses }}</h2>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card">
                <div class="body xl-purple">
                    <h6>Unidades</h6>
                    <h2 class="m-0">{{ stats.units }}</h2>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card">
                <div class="body xl-green">
                    <h6>Apartados</h6>
                    <h2 class="m-0">{{ stats.sections }}</h2>
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="card">
                <div class="body xl-pink">
                    <h6>Talleres</h6>
                    <h2 class="m-0">{{ stats.workshops }}</h2>
                </div>
            </div>
        </div>
    </b-row>

    <!--<b-row>
        <b-col style="text-align:center">
          <h5>Organigrama</h5>
        </b-col>
    </b-row>-->

    <!-- Para crear unidades, apartados, talleres -->
    <searchtexts idModal="modal-index" :showButton="false" ref="modal-search-text"
      v-on:selected="saveResource($event)" v-bind:title="titleSearch">
    </searchtexts>
    <movelevels idModal="modal-move" ref="modal-move-level"
       v-on:selectedItem="selectItem($event)">
    </movelevels>

    <b-row>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="body">

          <div class="d-flex justify-content-between align-items-center mb-4 px-2">
            <h3 class="p-0 m-0">Cursos</h3>
            <button class="btn btn-outline-secondary ml-auto mr-3" type="button"
              v-if="checkUserEdit() && !checkUserEditSecondary()"
              @click="showModalResource($event, 'course', 0, 'Añadir curso')">
              + Añadir curso
            </button>
          </div>

          <div class="dd">
            <ol class="dd-list pointer">
              <li v-for="(course, indexCourse) of contentBrowser" class="dd-item"
                v-bind:data-id="indexCourse" v-bind:key="indexCourse"
                @click="showOrHideItem($event, 'course_units', indexCourse)"
                @mouseout="hoverDelete($event, indexCourse, null, null, 'H')"
                @mousemove="hoverDelete($event, indexCourse, null, null, 'S')">
                    <div :class="'dd-handle'+getCourseClass(course.curso)" v-bind:id="'course_' + indexCourse">
                      <div class="row">
                        <div class="col col-md-8">
                          <h5 class="title-contentbrowser mb-2"><strong>C:</strong> {{ course.name[`TEXTO_${languageGlobal}`] }}</h5>
                          <div :class="course.zeroExercises ? 'zeroExercises': ''" v-html="course.total"></div>
                        </div>
                        <div class="col col-md-4" v-if="checkUserEdit() && !checkUserEditSecondary() /*|| (course.curso > 20 && checkUserEditSecondary())*/">
                          <button class="btn btn-icon btn-sm btn-round btn-danger hide float-right"
                            @click="deleteItem($event, 'course', course.id)" type="button" title="Eliminar Curso">
                              <i class="fa fa-trash"></i>
                          </button>

                          <button class="btn btn-icon btn-sm btn-round btn-success hide float-right"
                            @click="showModalResource($event, 'unit', course.id, 'Añadir unidad')" title="Añadir Unidad">
                              <i class="fa fa-plus"></i>
                            </button>
                        </div>
                      </div>
                    </div>

                  <ol class="dd-list pointer" v-if="course.hasChildren"
                    v-bind:id="'course_units_' + indexCourse" style="display: none">
                      <li v-for="(unit, indexUnit) of course.nodes" class="dd-item"
                        v-bind:data-id="indexUnit" v-bind:key="indexUnit"
                        @click="showOrHideItem($event, 'unit_sections_'+indexCourse, indexUnit)"
                        @mouseout="hoverDelete($event, indexCourse, indexUnit, null, 'H')"
                        @mousemove="hoverDelete($event, indexCourse, indexUnit, null, 'S')">
                          <div class="dd-handle"
                            v-bind:id="'course_' + indexCourse + '_unit_' + indexUnit">
                              <div class="row">
                                <div class="col col-md-8">
                                  <h5 class="title-contentbrowser mb-2"><strong>U: </strong> {{ unit.name[`TEXTO_${languageGlobal}`] }}</h5>
                                  <div :class="unit.zeroExercises ? 'zeroExercises': ''" v-html="unit.total"></div>
                                </div>
                                <div class="col col-md-4" v-if="checkUserEdit() && !checkUserEditSecondary()">
                                  <button class="btn btn-icon btn-sm btn-round btn-danger hide float-right"
                                    @click="deleteItem($event, 'unit', unit.id)" title="Eliminar Unidad">
                                      <i class="fa fa-trash"></i>
                                  </button>
                                  <button class="btn btn-icon btn-sm btn-round btn-success hide float-right"
                                    @click="showModalResource($event, 'section', unit.id, 'Añadir apartado')" title="Añadir Apartado">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-icon btn-sm btn-round btn-primary hide  float-right"
                                    @click="showModalMoveResources($event, 'unit', unit.id, 'course')" title="mover">
                                    <i class="fa fa-sort"></i>
                                  </button>
                                  <button class="btn btn-icon btn-sm btn-round btn-info hide  float-right"
                                    @click="moveItem($event, 'unit', unit.id, 'up')" title="Bajar">
                                    <i class="fa fa-caret-down"></i>
                                  </button>
                                  <button class="btn btn-icon btn-sm btn-round btn-info hide float-right"
                                    @click="moveItem($event, 'unit', unit.id, 'down')" title="Subir">
                                    <i class="fa fa-caret-up"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                        <ol class="dd-list pointer" v-if="unit.hasChildren"
                          v-bind:id="'unit_sections_' + indexCourse + '_' + indexUnit"   style="display: none">
                            <li class="dd-item" v-for="(section, indexSection) of unit.nodes"
                              v-bind:data-id="indexSection"
                              v-bind:key="indexSection"
                              @click="getWorkshops($event, section.id, section.name)"
                              @mouseout="hoverDelete($event, indexCourse, indexUnit,
                                indexSection, 'H')"
                              @mousemove="hoverDelete($event, indexCourse, indexUnit,
                                indexSection, 'S')">
                              <div class="dd-handle"
                                v-bind:id="'course_' + indexCourse + '_unit_' +
                                indexUnit + '_section_' + indexSection">
                                <div class="row">
                                  <div class="col col-md-8">
                                  <h5 class="title-contentbrowser mb-2"><strong>A:</strong> {{ section.name[`TEXTO_${languageGlobal}`] }}</h5>
                                  <div :class="section.zeroExercises ? 'zeroExercises': ''" v-html="section.total"></div>
                                  </div>
                                  <div class="col col-md-4" v-if="checkUserEdit() && !checkUserEditSecondary()">
                                    <button class="btn btn-icon btn-sm btn-round btn-danger hide float-right"
                                      @click="deleteItem($event, 'section', section.id)" title="Eliminar Apartado">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                    <button class="btn btn-icon btn-sm btn-round btn-primary hide  float-right"
                                      @click="showModalMoveResources($event, 'section', section.id, 'units')" title="Mover">
                                      <i class="fa fa-sort"></i>
                                    </button>
                                    <button class="btn btn-icon btn-sm btn-round btn-info hide float-right"
                                      @click="moveItem($event, 'section', section.id, 'up')" title="Bajar">
                                      <i class="fa fa-caret-down"></i>
                                    </button>
                                    <button class="btn btn-icon btn-sm btn-round btn-info hide float-right"
                                      @click="moveItem($event, 'section', section.id, 'down')" title="Subir">
                                      <i class="fa fa-caret-up"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </li>
                        </ol>
                      </li>
                  </ol>
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="card workshop-viewer" v-if="hasSection">
          <div class="body">
              <div class="d-flex justify-content-between align-items-center mb-4 px-2">
                <h4 class="p-0 m-0"><strong>A:</strong> {{ sectionName[`TEXTO_${languageGlobal}`] }}</h4>
                <button class="btn btn-outline-secondary ml-auto mr-3" type="button" v-if="checkUserEdit() && !checkUserEditSecondary()"
                  @click="showModalResource($event, 'workshop', section, 'Añadir taller')">
                  + Añadir taller
                </button>
              </div>

              <div class="table-responsive table-workshops">
                <table class="table table-striped m-b-0 overflow-hidden">
                  <tbody>
                    <tr v-for="(workshop, index) of workshops" v-bind:key="index" class="workshop-item">
                      <td>
                        <div class="row">
                          <div class="col col-md-8">
                            <router-link target="_blank" class="title-contentbrowser"
                              :to="{ name: 'workshopexercises', params: { id: workshop.ID }}">
                              <strong>T:</strong> {{ workshop.text[`TEXTO_${languageGlobal}`] }}
                            </router-link>
                            <div class="mt-2" :class="workshop.workshop_columns.length === 0 ? 'zeroExercises': ''">
                              <span class="tree-exercise" title="Núm. Ejercicios">
                                E: {{ workshop.workshop_columns.length }}
                              </span>
                            </div>
                          </div>
                          <div class="col col-md-4" v-if="checkUserEdit() && !checkUserEditSecondary()">
                            <button class="btn btn-icon btn-sm btn-round btn-danger float-right" type="button"
                              @click="deleteWorkshop($event, workshop.ID)" title="Eliminar">
                              <i class="fa fa-trash"></i>
                            </button>
                            <button class="btn btn-icon btn-sm btn-round btn-warning float-right" type="button"
                              @click="duplicateWorkshop($event, workshop.ID)" title="Duplicar">
                              <i class="fa fa-copy"></i>
                            </button>
                            <button class="btn btn-icon btn-sm btn-round btn-primary float-right" type="button"
                              @click="showModalMoveResources($event, 'workshop', workshop.ID, 'section')" title="mover">
                              <i class="fa fa-sort"></i>
                            </button>
                            <button class="btn btn-icon btn-sm btn-round btn-info float-right" type="button"
                              @click="moveItem($event, 'workshop', workshop.ID, 'up')" title="Bajar">
                              <i class="fa fa-caret-down"></i>
                            </button>
                            <button class="btn btn-icon btn-sm btn-round btn-info float-right" type="button"
                              @click="moveItem($event, 'workshop', workshop.ID, 'down')" title="Subir">
                              <i class="fa fa-caret-up"></i>
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>
        </div>
      </div>
    </b-row>
  </div>
</div>

</template>

<script>
import $ from 'jquery';
import searchtexts from '../texts/SearchTexts.vue';
import movelevels from './MoveLevels.vue';

export default {
  name: 'organigrama',
  components: {
    searchtexts, movelevels,
  },
  data() {
    return {
      user: null,
      titleSearch: 'Añadir curso',
      stats: {
        courses: null,
        units: null,
        sections: null,
        workshops: null,
      },
      contentBrowser: [],
      workshops: [],
      sectionName: '',
      section: null,
      hasSection: false,
      resource: null,
      resourceId: null,
      resourceIdMoveLevel: null,
    };
  },
  methods: {
    /**
    * @method getStats
    * @description Estadísticas
    */
    async getStats() {
      this.loading = true;
      try {
        const response = await this.axios.get('content-browser/stats');
        const {
          courses,
          units,
          sections,
          workshops,
        } = response.data.data[0];

        this.stats.courses = courses;
        this.stats.units = units;
        this.stats.sections = sections;
        this.stats.workshops = workshops;
      } catch (e) {
        // Nothing
      }

      this.loading = false;
    },
    /**
    * @method getContentBrowser
    * @description Organigrama
    */
    async getContentBrowser() {
      this.loading = true;
      try {
        const response = await this.axios.get('content-browser');
        this.contentBrowser = response.data.data;
        this.$refs['modal-move-level'].levels = this.contentBrowser;
      } catch (e) {
        // Nothing
      }

      this.loading = false;
    },
    /**
    * @method getWorkshops
    * @description Obtengo los talleres
    */
    async getWorkshops(event, id, name) {
      try {
        event.stopPropagation();
      } catch (e) {
        // Nothing
      }

      this.loading = true;
      try {
        const response = await this.axios.get(`content-browser/workshops/${id}`);
        this.workshops = response.data.data;
        this.sectionName = name;
        this.hasSection = true;
        this.section = id;
      } catch (e) {
        this.cleanWorkshops();
      }

      this.loading = false;
    },
    /**
    * @method cleanWorkshops
    * @description Limpia la sección de workshops
    * */
    cleanWorkshops() {
      this.hasSection = false;
      this.section = null;
      this.sectionName = '';
    },
    /**
    * @method duplicateWorkshop
    * @description Crear un nuevo taller
    * */
    async duplicateWorkshop(event, id) {
      const value = await this.confirm('¿Deseas duplicar el taller seleccionado?');

      if (value) {
        try {
          this.loading = true;
          const response = await this.axios.post(`workshop/duplicate/${id}`);
          await this.getWorkshops(event, this.section, this.sectionName);
          this.$toasted.show(response.data.message, { type: 'success' });
          this.loading = false;
        } catch (e) {
          this.loading = false;
          this.$toasted.show('Ocurrió un error al duplicar', { type: 'warning' });
        }
      }
    },
    /**
    * @method deleteWorkshop
    * @description Crear un nuevo taller
    * */
    async deleteWorkshop(event, id) {
      try {
        const value = await this.confirm('¿Desea eliminar el taller seleccionado?');

        if (value) {
          this.loading = true;
          const response = await this.axios.delete(`workshop/${id}`);
          await this.getWorkshops(event, this.section, this.sectionName);
          this.loading = false;
          this.$toasted.show(response.data.message, { type: 'success' });
        }
      } catch (e) {
        this.loading = false;
        this.$toasted.show('Ocurrió un error al eliminar', { type: 'warning' });
      }
    },
    /**
    * @method deleteSection
    * @description Elimina una sección
    */
    async deleteItem(event, type, id) {
      event.stopPropagation();

      try {
        let message = '';
        switch (type) {
          case 'course':
            message = 'el curso seleccionado';
            break;
          case 'unit':
            message = 'la unidad seleccionada';
            break;
          case 'section':
            message = 'el apartado seleccionado';
            break;
          default:
            break;
        }

        const value = await this.confirm(`¿Desea eliminar ${message}?`);
        if (value) {
          this.loading = true;
          const response = await this.axios.delete(`${type}/${id}`);
          await this.getContentBrowser();
          this.cleanWorkshops();
          this.loading = false;
          this.$toasted.show(response.data.message, { type: 'success' });
        }
      } catch (e) {
        this.loading = false;
        this.$toasted.show('Ocurrió un error al eliminar', { type: 'warning' });
      }
    },
    /**
    * @method selectItem
    * @description Selecciona un nivel diferente para un recurso.
    */
    async selectItem(data) {
      try {
        let message = '';
        switch (data.type) {
          case 'course':
            message = 'la unidad al curso seleccionado';
            break;
          case 'unit':
            message = 'el apartado a la unidad seleccionada';
            break;
          case 'section':
            message = 'el taller al apartado seleccionado';
            break;
          default:
            break;
        }
        const value = await this.confirm(`¿Desea mover ${message}?`);
        if (value) {
          // console.log(data.id);
          this.loading = true;
          const response = await this.axios.post(`workshop/move-resource-level/${this.resourceIdMoveLevel}/${data.levelId}/${data.type}`);
          this.$root.$emit('bv::hide::modal', 'modal-move');
          if (response.data.status === 'success') {
            await this.getContentBrowser();
            this.cleanWorkshops();
            this.$toasted.show(response.data.message, { type: 'success' });
          }
          this.resourceIdMoveLevel = null;
          this.loading = false;
        }
      } catch (e) {
        this.loading = false;
        this.$toasted.show('Ocurrió un error al seleccionar', { type: 'warning' });
      }
    },
    /**
    * @method moveItem
    * @description Mover elemento arriba o abajo segun la POSICION
    * direction: up (arriba) down (abajo).
    * IMPORTANT: Up means increase POSICION value, which turns into viewing it go down in the list, hence de swap in icons.
    */
    async moveItem(event, type, id, direction) {
      event.stopPropagation();
      try {
        this.loading = true;
        let response = null;

        if (type === 'unit') {
          response = await this.axios.post(`workshop/move-unit-item/${id}/${direction}`);
        } else if (type === 'section') {
          response = await this.axios.post(`workshop/move-section-item/${id}/${direction}`);
        } else if (type === 'workshop') {
          response = await this.axios.post(`workshop/move-workshop-item/${id}/${direction}`);
        }

        if (response.data.status === 'success') {
          await this.getContentBrowser();

          if (type === 'workshop') {
            await this.getWorkshops(null, this.section, this.sectionName);
          } else {
            this.cleanWorkshops();
          }

          this.$toasted.show(response.data.message, { type: 'success' });
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$toasted.show('Ocurrió un error al tratar de mover un elemento', { type: 'warning' });
      }
    },


    getCourseClass(curso) {
      if ((this.checkUserViewerSecondary() || this.checkUserEditSecondary()) && curso < 20) { // 21 And above are for secundaria courses
        return ' disabled';
      }
      return '';
    },
    /**
    * @method showOrHideItem
    * @description Oculta o muestro un item del organigrama
    */
    showOrHideItem(e, key, indexCourse) {
      if (e !== null) {
        e.stopPropagation();
      }

      // Means we are opening a course from primary
      if (key === 'course_units' && this.contentBrowser[indexCourse].curso < 20) {
        if (this.checkUserViewerSecondary() || this.checkUserEditSecondary()) {
          e.stopPropagation();
          e.preventDefault();
          return;
        }
      }

      const id = `#${key}_${indexCourse}`;
      $(id).slideToggle();
    },
    /**
    * @method hoverDelete
    * @description Oculta o muestra el botón delete para cursos, unidades y talleres
    */
    hoverDelete(e, indexCourse, indexUnit, indexSection, type) {
      e.stopPropagation();

      let key;
      if (indexCourse !== null && indexUnit !== null && indexSection !== null) {
        key = `#course_${indexCourse}_unit_${indexUnit}_section_${indexSection}`;
      } else if (indexCourse !== null && indexUnit !== null) {
        key = `#course_${indexCourse}_unit_${indexUnit}`;
      } else {
        key = `#course_${indexCourse}`;
      }

      const element = $(`${key} > .row > .col > button`);
      if (type === 'S') {
        element.show();
      } else {
        element.hide();
      }
    },
    /**
    * @method confirmDelete
    * @description Modal para confirmar acción
    */
    async confirm(message) {
      const result = await this.$bvModal.msgBoxConfirm(message, {
        title: 'Confirmar',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Sí',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
      });

      return result;
    },
    /**
    * @method showModalResource
    * @description Dispara el modal para agregar recursos
    */
    async showModalResource(event, type, resourceId, title) {
      event.preventDefault();
      this.$refs['modal-search-text'].reset();
      this.resource = type;
      this.resourceId = resourceId;
      this.titleSearch = title;
      this.$root.$emit('bv::show::modal', 'modal-index');
    },
    /**
    * @method showModalMoveResources
    * @description Dispara el modal para mover recursos (Unidad - Apartado - Talleres)
    */
    async showModalMoveResources(event, type, resourceId, resourcelevel) {
      event.preventDefault();
      this.resourceIdMoveLevel = resourceId;
      this.$refs['modal-move-level'].type = type;
      this.$refs['modal-move-level'].resourcelevel = resourcelevel;
      this.$root.$emit('bv::show::modal', 'modal-move');
    },
    /**
    * @method saveResource
    * @description Graba recursos: Curso, unidad, apartado, taller
    */
    async saveResource(data) {
      this.loading = true;
      const self = this;

      try {
        if (this.resourceId === 'course') {
          await this.axios.post(this.resource, {
            Id: self.resourceId,
            TEXT_ID: data.ID,
            CURSO: 0, // Default course num
          });
        } else {
          await this.axios.post(this.resource, {
            Id: self.resourceId,
            TEXT_ID: data.ID,
          });
        }

        await this.getContentBrowser();

        if (this.resource === 'workshop') {
          await this.getWorkshops(null, this.section, this.sectionName);
        }
      } catch (e) {
        this.$toasted.show('Ocurrió un error al grabar', { type: 'warning' });
      }

      this.loading = false;
      this.$root.$emit('bv::hide::modal', 'modal-index');
      this.resource = null;
      this.resourceId = null;
    },
    /**
    * @method parseQueryString
    * @description Parsea el querystring
    */
    parseQueryString() {
      const self = this;
      const q = this.$route.query;
      if (q.courseId !== undefined) {
        const courseId = parseInt(q.courseId, 10);
        const indexCourse = this.contentBrowser.findIndex(c => c.id === courseId);

        setTimeout(() => {
          self.showOrHideItem(null, 'course_units', indexCourse);
        }, 100);

        if (q.unitId !== undefined) {
          const unitId = parseInt(q.unitId, 10);
          const indexUnit = self.contentBrowser[indexCourse].nodes.findIndex(c => c.id === unitId);

          setTimeout(() => {
            self.showOrHideItem(null, `unit_sections_${indexCourse}`, indexUnit);
          }, 100);

          if (q.sectionId !== undefined) {
            const sectionId = parseInt(q.sectionId, 10);
            try {
              const section = self.contentBrowser[indexCourse].nodes[indexUnit].nodes.filter(c => c.id === sectionId)[0];
              self.getWorkshops(self.$event, section.id, section.name);
            } catch (e) {
              // Nothing
            }
          }
        }
      }
    },
  },
  async mounted() {
    await this.getStats();
    await this.getContentBrowser();

    if (this.$route.query !== undefined) {
      this.parseQueryString();
    }
  },
};
</script>

<style lang="scss">

.hide {
  display: none;
}
.dd-handle {
  min-height: 75px;
}

.dd-handle.disabled {
  color: #999 !important;
}
.dd-handle.disabled:hover {
  border: 1px solid #f0f0f0 !important;
  color: #999 !important;
  cursor: default;
}

.title-contentbrowser {
  font-size: 0.9rem;
}

.table-workshops {
  border-collapse: collapse;
  border-radius: 5px;
  border-style: hidden;
  box-shadow: 0 0 0 1px #cdcdcd;
  max-height: 78vh;
}

.workshop-viewer {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 3vh;
}


.tree-unit,
.tree-block,
.tree-workshop,
.tree-exercise {
  border-radius: 3px;
  padding: 4px;
  color: #333333;
  margin-right: 5px;
  font-size: 0.7rem;
}


.tree-unit {
  background-color: rgba(70, 182, 254, 0.5) !important;
}
.tree-block {
  background-color: rgba(111, 66, 193, 0.5) !important
}
.tree-workshop {
  background-color: rgba(4, 190, 91, 0.5) !important
}
.tree-exercise {
  background-color: rgba(255, 77, 171, 0.5) !important
}
.zeroExercises .tree-exercise {
  background-color: red !important;
  color: white;
}
</style>
